import type { FC, MouseEvent } from "react";

import {
  type ISelectionModel,
  isSelected,
  type TGridSelModelIdentifier,
} from "../../../../../app-utils/selection-model.js";
import { type IAgGridCellProps } from "../../cell-base-interfaces.js";
import { TableCell } from "./TableCell.js";

export interface CheckboxCellProps extends IAgGridCellProps {
  onChange: (rowIndex: number, rowId: TGridSelModelIdentifier, selected: boolean, rangeCheck: boolean) => void;
  // Pass the selection model from the context to determine checked state
  selectionModel?: ISelectionModel;
}

const CheckboxCell: FC<CheckboxCellProps> = (props) => {
  const handleChange = (event: MouseEvent, rowIndex: number, rowId: TGridSelModelIdentifier, checked: boolean) => {
    const rangeCheck: boolean = event.nativeEvent.shiftKey; // get from original dom event
    props.onChange(rowIndex, rowId, checked, rangeCheck);
  };

  if (props.data) {
    const { data } = props;
    const rowIndex = props.node?.rowIndex;

    const rowId: TGridSelModelIdentifier = data.id || props.node.id;

    // Use our custom selection model instead of ag-Grid's internal selection state
    const checked = props.selectionModel ? isSelected(props.selectionModel, rowId) : props.node.isSelected();

    const checkboxId = `checkbox_${data.groupType}_${rowIndex}`;

    return (
      <TableCell>
        <div className="checkbox" style={{ margin: 0, marginTop: 4, marginLeft: 1, padding: 0 }}>
          {data.isSelectable !== false && (
            <>
              <input
                type="checkbox"
                key={checkboxId}
                id={checkboxId}
                checked={checked}
                onChange={() => null}
                data-checked={checked}
              />
              <label htmlFor={checkboxId} onClick={(event) => handleChange(event, rowIndex ?? -1, rowId, !checked)} />
            </>
          )}
        </div>
      </TableCell>
    );
  }

  return null;
};

export default CheckboxCell;
